export const mixUrlWithParamns = (url, paramns) => {
  let searchParamns = "";
  for (var p in paramns) {
    if (searchParamns === "") {
      searchParamns += `?${p}=${paramns[p]}`;
    } else {
      searchParamns += `&${p}=${paramns[p]}`;
    }
  }
  return url + searchParamns;
};

export const isHamburguerMenu = (profile) => {
  switch (profile) {
    case "farmer":
    case "warehouse":
    case "driver":
      return false;
    default:
      return true;
  }
};

//Check if object is empty.
export const isEmpty = (obj) => {
  return JSON.stringify(obj) === "{}";
};

export const checkAdminUser = user => {
  if (user.user_group === "user_admin" && user.type === "transporter") {
    return "Gerente de Transportadora";
  }

  if(user.user_group !== "user_admin" && user.type === "transporter") {
    return "Transportador";
  }

  if (user.user_group === "driver" && user.type === "driver") {
    return "Motorista";
  }

  if (user.user_group === "user_admin" && user.type === "client") {
    return "Cliente";
  }
};
